module.exports = __webpack_public_path__ + "static/media/tutorial1.744b1913.png";